export const registerMinLength = (value) => ({
    minLength: {
        value: value,
        message: `Text should have minimum ${value} characters`,
    },
});
